import { render, staticRenderFns } from "./normaltop.vue?vue&type=template&id=0a41acaa&scoped=true&"
import script from "./normaltop.vue?vue&type=script&lang=js&"
export * from "./normaltop.vue?vue&type=script&lang=js&"
import style0 from "./normaltop.vue?vue&type=style&index=0&id=0a41acaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a41acaa",
  null
  
)

export default component.exports